import { render } from "./IndexSwiper.vue?vue&type=template&id=adee26d6&scoped=true"
import script from "./IndexSwiper.vue?vue&type=script&lang=js"
export * from "./IndexSwiper.vue?vue&type=script&lang=js"

import "./IndexSwiper.vue?vue&type=style&index=0&id=adee26d6&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-adee26d6"]])

export default __exports__